import { ModalId } from '@heidi/schema/ml-scribe';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { showEnabledToastOnEducationCloseAtom } from '../atoms';
import { useSessionMergeOnboardingUiHost } from '../host';

/** Mirrors the app queue's `ModalPriority.NORMAL`. */
export const SESSION_MERGE_EDUCATION_PRIORITY = 5;

/**
 * Post-enable follow-up shared by every path that turns auto session merge on
 * ("Turn on" on the awareness cards, the settings toggle). Every enable opens
 * the instructional modal — deliberately not seen-gated, so re-enabling from
 * the settings toggle re-teaches the matching behaviour — and arms
 * `showEnabledToastOnEducationCloseAtom` so the "Session merge enabled" toast
 * fires once the modal is dismissed.
 */
export function useShowSessionMergeInstructions(): {
  showSessionMergeInstructions: () => void;
} {
  const { useEnqueueModal } = useSessionMergeOnboardingUiHost();
  const enqueueModal = useEnqueueModal();
  const setShowToastOnEducationClose = useSetAtom(showEnabledToastOnEducationCloseAtom);

  const showSessionMergeInstructions = useCallback(() => {
    setShowToastOnEducationClose(true);
    enqueueModal({
      id: ModalId.SESSION_MERGE_EDUCATION,
      priority: SESSION_MERGE_EDUCATION_PRIORITY,
      dismissible: true,
    });
  }, [enqueueModal, setShowToastOnEducationClose]);

  return { showSessionMergeInstructions };
}
